import { useDispatch, useSelector } from "react-redux"; // Hooks to interact with the Redux store
import { useEffect, useState } from "react"; // React hooks for lifecycle and local state
import { useLocation } from "react-router-dom"; // Hook to get the current location object

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

// Main component for managing UI behavior and logic for common tabs
const CommonTabsApp = () => {
    // Get the development configuration from Redux state
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { isAttendanceSupervisor } = useSelector((state) => state.AttendancePersistSlice);
    // Get the authenticated user's data and permissions from Redux state
    const { user, permission, getUserByIdAtEntry} = useSelector((state) => state.authenticatioauthennSlice);

    // React Router hook to get current route information
    const location = useLocation();

    // Redux dispatch function
    const dispatch = useDispatch();

    // Local state variables
    const [changeStyle, setChangeStyle] = useState(null); // Tracks the selected menu item's style
    const [isHovering, setIsHovering] = useState('1'); // Tracks which item is being hovered
    const [openMenu, setOpenMenu] = useState(null); // Tracks which submenu is currently open
    const [currentUrl, setCurrentUrl] = useState(window.location.pathname); // Tracks the current URL path
    const parts = currentUrl.split('/'); // Split the URL into parts for contextual use

    /**
     * Toggles the open state of a submenu.
     * If the clicked menu is already open, it closes it; otherwise, it opens it.
     * @param {string} menuId - Identifier of the menu item to toggle.
     */
    const handleMenuToggle = (menuId) => {
        setOpenMenu((prevMenu) => (prevMenu === menuId ? null : menuId));
    };

    /**
     * Closes any open submenu.
     */
    const handleClose = () => {
        setOpenMenu(null);
    };

    /**
     * Handles click on a menu item.
     * Updates the visual style state and stores the selected option in local state.
     * @param {string} menuName - Name of the clicked menu.
     */
    const handleMenuItemClick = (menuName) => {
        setChangeStyle(menuName);
    };

    /**
     * useEffect hook that updates the current URL state whenever the location changes.
     */
    useEffect(() => {
        setCurrentUrl(window.location.pathname);
    }, [location]);

    // Return all relevant variables and functions so they can be used in the consuming component
    return {
        DEV,
        permission,
        getUserByIdAtEntry,
        dispatch,
        parts,
        user,
        openMenu,
        changeStyle,
        setChangeStyle,
        isHovering,
        setIsHovering,
        currentUrl,
        setCurrentUrl,
        isAttendanceSupervisor,
        handleMenuToggle,
        handleMenuItemClick,
        handleClose
    };
}

export default CommonTabsApp; // Export the component to be used in other parts of the app
